// Having the same names (global.ts and global.d.ts) breaks Typescript, for some reason
import './module.d.ts';

// Add this script to the browser ignore list to have the calee's call location displayed
(['debug', 'log', 'error', 'info', 'trace'] as const).forEach((method) => {
  // @ts-ignore
  window[method] =
    function <T, Rest>(first: T, ...args: Rest[]): T {
      console[method](first, ...args);
      return first;
    };
});

window.sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
